import cn from 'classnames'
import style from '../PaymentMethods.module.scss'

export const Erip = () => (
  <div className={style.erip}>
    <h2>Оплата услуг через ЕРИП (Расчет)</h2>
    <p>
      Оплатить услуги КОСМОС Телеком Вы можете через систему ”Расчет“ (ЕРИП),
      в любом удобном для Вас месте, в удобное для Вас время, в удобном для
      Вас пункте банковского обслуживания – интернет-банке, с помощью
      мобильного банкинга, инфокиоске, кассе банков, банкомате и т.д. (
      <span>
        <a
          target="_blank"
          href="https://raschet.by/main.aspx?guid=7941"
          rel="noreferrer"
        >
          полный перечень пунктов банковского обслуживания
        </a>
      </span>
      ).
    </p>
    <p>
      Совершить оплату можно с использованием наличных денежных средств,
      электронных денег и банковских платежных карточек в пунктах банковского
      обслуживания банков, которые оказывают услуги по приему платежей, а
      также посредством инструментов дистанционного банковского
      обслуживания.
    </p>

    <h3>Для проведения платежа необходимо:</h3>
    <div className={style.punkts}>
      {/* <div className={style.numb}>1</div> */}
      <div className={style.n_text}>Выбрать</div>
    </div>
    {/* <div className="banks und"> */}
    <div className={cn(style.banks, style.und)}>
      <ul>
        <li>
          Пункт
          <span className={style.black}> “Система “Расчет” (ЕРИП)</span>
        </li>
        <li><span className={style.black}>Интернет, Телевидение</span></li>
        <li><span className={style.black}>Космос ТВ</span></li>
      </ul>
    </div>
    <div className={style.punkts}>
      {/* <div className={style.numb}>2</div> */}
      <div className={style.n_text}>Для оплаты ввести Номер контракта</div>
    </div>
    <div className={style.punkts}>
      {/* <div className={style.numb}>3</div> */}
      <div className={style.n_text}>Ввести сумму платежа (если не указана)</div>
    </div>
    <div className={style.punkts}>
      {/* <div className={style.numb}>4</div> */}
      <div className={style.n_text}>Проверить корректность информации</div>
    </div>
    <div className={style.punkts}>
      {/* <div className={style.numb}>5</div> */}
      <div>Совершить платеж.</div>
    </div>

    <p className={style.punkts_descr}>
      Если Вы осуществляете платеж в кассе банка,
      пожалуйста, сообщите кассиру о необходимости проведения платежа через
      систему ”Расчет“(ЕРИП).
    </p>

  </div>
)
